import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    settings: {
        id: 'settings.settings',
        defaultMessage: 'Settings',
    },
    general: {
        id: 'settings.general',
        defaultMessage: 'General',
    },
    verification: {
        id: 'settings.verification',
        defaultMessage: 'Verification',
    },
    account: {
        id: 'settings.account',
        defaultMessage: 'Account',
    },
    security: {
        id: 'settings.security',
        defaultMessage: 'Security',
    },
    changesSaved: {
        id: 'settings.changesSaved',
        defaultMessage: 'Changes saved',
    },
    sessions: {
        id: 'settings.sessions_active',
        defaultMessage: 'Active sessions',
    },
})
